import { base32 } from "@scure/base";

/** RFC 4648 base32 encoding, no padding (no trailing `=`). */
export function base32EncodeNoPad(data: Uint8Array): string {
  return base32.encode(data).replace(/=+$/, "");
}
